module.exports = __webpack_public_path__ + "media/images/categories/resturant-73e182f1b8bfd21c125a20b3033d2685.png";